// src/components/shell/PrimaryNav.jsx
import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { NAV_ITEMS } from './navigation';

/**
 * The app's sections as labelled tabs.
 *
 * These replaced four icon-only navbar buttons whose only label was a tooltip —
 * which never appears on touch, and which gave no hint of where you already
 * were. The current section carries aria-current="page".
 */
export default function PrimaryNav() {
    const { pathname } = useLocation();
    const { user } = useContext(UserContext);

    return (
        <nav className="qd-nav" aria-label="Main">
            <ul className="qd-nav__list">
                {NAV_ITEMS.filter((item) => !item.adminOnly || user?.isPlatformAdmin).map((item) => (
                    <li key={item.to}>
                        <Link
                            to={item.to}
                            className="qd-nav__link"
                            aria-current={item.match(pathname) ? 'page' : undefined}
                        >
                            <span className="qd-nav__label">{item.label}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </nav>
    );
}
